import { escapeHtml } from "./dom.js";

function pct(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  if (n <= 1) return `${(n * 100).toFixed(0)}%`;
  return `${n.toFixed(0)}%`;
}

function listOrEmpty(items, emptyLabel, mapFn) {
  const arr = Array.isArray(items) ? items : [];
  if (!arr.length) return `<p class="muted" style="margin:0;font-size:12px">${escapeHtml(emptyLabel)}</p>`;
  return `<ul class="oncr-ux-list">${arr.slice(0, 8).map(mapFn).join("")}</ul>`;
}

/**
 * ONCR O9 — Observation / Hypothesis / Intent / Prediction cards for Incident Console.
 */
export function oncrIncidentUxHtml(view) {
  const data = view && typeof view === "object" ? view : {};
  if (!data.oncr) {
    return `<p class="muted">ONCR view unavailable.</p>`;
  }
  const caps = Array.isArray(data.capabilities_mounted) ? data.capabilities_mounted.join(", ") : "—";
  const loop = Array.isArray(data.loop_states) ? data.loop_states.join(" → ") : "observe → interpret → predict → decide";

  const obsHtml = listOrEmpty(
    data.observations,
    "No observations in fabric window yet.",
    (o) =>
      `<li><span class="mono">${escapeHtml(o.observation_type || "obs")}</span>` +
      ` <span class="muted">${escapeHtml(String(o.source_kind || ""))}</span></li>`,
  );
  const hypHtml = listOrEmpty(
    data.hypotheses,
    "No working hypotheses yet.",
    (h) =>
      `<li data-oncr-crown="${escapeHtml((h.crown && h.crown.band) || "")}">` +
      `<strong>${escapeHtml((h.crown && h.crown.text) || h.label || "Hypothesis")}</strong>` +
      ` · ${escapeHtml(pct(h.confidence))} · <span class="badge">${escapeHtml(h.status || "open")}</span>` +
      (Array.isArray(h.evidence_gaps) && h.evidence_gaps.length
        ? ` <span class="muted">gaps: ${escapeHtml(h.evidence_gaps.slice(0, 3).join(", "))}</span>`
        : "") +
      `</li>`,
  );
  const polHtml = listOrEmpty(
    data.policy_candidates,
    "No policy candidates.",
    (p) =>
      `<li><span class="mono">${escapeHtml(p.policy_id || "")}</span>` +
      ` · score ${escapeHtml(String(p.score ?? "—"))}` +
      ` · intents ${(Array.isArray(p.intent_codes) ? p.intent_codes : []).map((c) => escapeHtml(c)).join(", ")}` +
      `</li>`,
  );
  const intentHtml = listOrEmpty(
    data.intents,
    "No intents yet (shadow canary default).",
    (i) =>
      `<li><span class="mono">${escapeHtml(i.intent_code || i.status || "intent")}</span>` +
      ` · ${escapeHtml(i.status || "")}` +
      (i.shadow ? ` <span class="badge">shadow</span>` : "") +
      (i.hypothesis_id ? ` <span class="muted">from ${escapeHtml(String(i.hypothesis_id).slice(0, 12))}</span>` : "") +
      `</li>`,
  );
  const predHtml = listOrEmpty(
    data.predictions,
    "No scheduled predictions.",
    (p) =>
      `<li><span class="mono">${escapeHtml(p.observation_type || "obs")}</span>` +
      ` · due ${escapeHtml(p.due_at || "")}</li>`,
  );

  return `<div class="oncr-ux-panel" data-oncr="1">
  <p class="muted" style="margin:0 0 8px;font-size:11px">Cognitive loop: ${escapeHtml(loop)} · mounted: ${escapeHtml(caps || "rules")}</p>
  <div class="ops-fcm-mig-cols">
    <div class="ops-fcm-mig-col"><p class="muted ops-fcm-mig-col-title">Observations</p>${obsHtml}</div>
    <div class="ops-fcm-mig-col"><p class="muted ops-fcm-mig-col-title">Hypotheses</p>${hypHtml}</div>
    <div class="ops-fcm-mig-col"><p class="muted ops-fcm-mig-col-title">Policy → Intent</p>${polHtml}${intentHtml}</div>
    <div class="ops-fcm-mig-col"><p class="muted ops-fcm-mig-col-title">Predictions</p>${predHtml}</div>
  </div>
</div>`;
}
